var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',_vm._l((_vm.monitors),function(monitor,i){return _c('status-bar',{key:i,staticClass:"mb-4",attrs:{"item":monitor,"name":monitor.name}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }